import { hasCapability, type User } from "../base";

export const globalAppSettings = {
  read: (user: User) => hasCapability(user, "globalAppSettings.read"),
  update: (user: User) => hasCapability(user, "globalAppSettings.update"),
};
